import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-516e0da5")

_pushScopeId("data-v-516e0da5")
const _hoisted_1 = { class: "notification-slot-wrapper" }
const _hoisted_2 = {
  "aria-labelledby": "swal2-title",
  "aria-describedby": "swal2-content",
  class: "swal2-popup swal2-modal swal2-icon-info swal2-show",
  tabindex: "-1",
  role: "dialog",
  "aria-live": "assertive",
  "aria-modal": "true",
  style: {"display":"flex"}
}
const _hoisted_3 = { class: "swal2-header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "swal2-icon swal2-question swal2-icon-show",
  style: {"display":"flex"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "swal2-icon-content" }, "?")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "swal2-icon swal2-success",
  style: {"display":"none"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "swal2-image",
  style: {"display":"none"}
}, null, -1)
const _hoisted_7 = {
  class: "swal2-title",
  id: "swal2-title",
  style: {"display":"flex"}
}
const _hoisted_8 = { class: "swal2-content" }
const _hoisted_9 = { class: "swal2-actions" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "swal2-loader" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckBoxInput = _resolveComponent("CheckBoxInput")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('calendar.slot.orderNotificationSwalTitle')), 1),
        _createVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          class: "swal2-close",
          "aria-label": "Close this dialog",
          style: {"display":"flex"}
        }, "×")
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_CheckBoxInput, {
          modelValue: _ctx.isSms,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSms = $event)),
          name: "sms",
          value: "true",
          singleLine: true,
          label: _ctx.$t('sms-email-management.sms.label')
        }, null, 8, ["modelValue", "label"]),
        _createVNode(_component_CheckBoxInput, {
          modelValue: _ctx.isEmail,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEmail = $event)),
          name: "email",
          value: "true",
          singleLine: true,
          label: _ctx.$t('sms-email-management.email.label')
        }, null, 8, ["modelValue", "label"])
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode("button", {
          class: [_ctx.confirmButtonClass(), "swal2-confirm save-button-wrapper popup-bookit-button my-1 px-5"],
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args))),
          disabled: !_ctx.canConfirm(),
          type: "button",
          style: {"display":"inline-block"}
        }, _toDisplayString(_ctx.$t('alert.yesContinue')), 11, ["disabled"]),
        _createVNode("button", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          type: "button",
          class: "swal2-deny close-button-wrapper popup-bookit-button my-1 px-5",
          style: {"display":"inline-block"}
        }, _toDisplayString(_ctx.$t('alert.slot.no-dont-notify')), 1)
      ])
    ])
  ]))
})